

import React from 'react';
import { Link } from 'react-router-dom';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import { Icon } from '@iconify/react';
import Spacing from '../Spacing';
import Post from '../Post';
import Sidebar from '../Sidebar';
import AuthorWidget from '../Widget/AuthorWidget';
import CommentsWidget from '../Widget/CommentsWidget';
import ReplyWidget from '../Widget/ReplyWidget';
import { pageTitle } from '../../helpers/PageTitle';
const tags = [
  { tag: 'Emergency', href: '/blog/blog-details' },
  { tag: 'Pediatric', href: '/blog/blog-details' },
  { tag: 'Cardiology', href: '/blog/blog-details' },
  { tag: 'Psychiatry', href: '/blog/blog-details' },
  { tag: 'Others', href: '/blog/blog-details' },
];
const relatedBlog = [
  {
    title:
      'The Importance of Mental Health: Understanding and Managing Anxiety Disorders',
    thumbUrl: '/images/blog/post_1.jpeg',
    date: 'March 12',
    btnText: 'Learn More',
    href: '/blog/blog-details',
  },
  {
    title: `A Parent's Guide to Childhood Vaccinations: What You Need to Know`,
    thumbUrl: '/images/blog/post_2.jpeg',
    date: 'March 11',
    btnText: 'Learn More',
    href: '/blog/blog-details',
  },
  {
    title: 'Preventing Heart Disease: Tips for a Heart-Healthy Lifestyle',
    thumbUrl: '/images/blog/post_3.jpeg',
    date: 'March 9',
    btnText: 'Learn More',
    href: '/blog/blog-details',
  },
];

export default function Stig() {
  pageTitle('S tig');
  return (
    <>
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb />
      </Section>
      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            {/* <div className="cs_blog_details_tags">
              {tags.map((item, index) => (
                <Link key={index} to={item.href}>
                  {item.tag}
                </Link>
              ))}
            </div> */}
            <div className="cs_blog_details_date">
              STIG TABLET
            </div>
          </div>
          {/* <div className="cs_social_links_wrap">
            <h2>Share:</h2>
            <div className="cs_social_links">
              <Link to="/">
                <Icon icon="fa-brands:facebook-f" />
              </Link>
              <Link to="/">
                <Icon icon="fa-brands:linkedin-in" />
              </Link>
              <Link to="/">
                <Icon icon="fa-brands:twitter" />
              </Link>
            </div>
          </div> */}
        </div>
        <Spacing md="" />
        <img
          src="/images/home_1/pro3.jpeg"
          alt="Blog Details"
          className="w-100 cs_radius_20"
        />
        <Spacing md="" lg="50" />
        <div className="row">
          <div className="col-lg-8">
            <div className="cs_blog_details">
              <h2>S-TIG</h2>
              <p>
              This extract may help improve blood flow to the penis, potentially
leading to firmer erections.
 Tribulus Terrestris Extract (Protodioscin) Traditionally used as an aphrodisiac, Tribulus
Terrestris may enhance libido and testosterone production.
 Lepidiummeyenii Extract: This extract may have a positive impact on libido and sperm health.
 Muira puama Extract: IT may improve sperm count and motility while also potentially
reducing stress and anxiety.
 L-Arginine: L-Arginine is an amino acid that can convert to nitric oxide in the body, potentially
aiding blood flow.
 L Optizinc : Zinc is an essential mineral that plays a role in healthy testosterone levels and sperm
production. 
 <br />
                <br />
                S-TIG tablet Uses/Benefits:              </p>
              <ol>
                <li>
                  <b>Improved Erections</b>
                  <br />
                  
                </li>
                <li>
                  <b>Enhanced Libido</b> <br />
                 
                </li>
                <li>
                  <b>Increased Stamina</b>
                  <br />
                  
                </li>
                <li>
                  <b>Sperm Health</b>
                  <br />
                 
                </li>
                <li>
                  <b>Sperm Health</b> <br />
                 
                </li>
                <li>
                  <b>Dizziness</b> <br />
                 
                </li>
              </ol>
              <h2>STIG TAB DISCRIPTION</h2>

              <p>
              S TIG is a unique formulation for the quick and successful treatment of erectile
dysfunction (unlikely to keep an erection), male infertility while also boosting men's
health. It is a complete treatment for loss of desire, and lack of performance stamina. S
TIG contains 12 high-quality components, including a blend of Icariin (Horny Goat
Weed). It is the first brand in Pakistan to use Horny Goat Weed (400 mg) and is
recommended by prominent urologists, diabetologists, psychiatrists, sexologists, and
other health care professionals. The Icariin, L arginine, and Yohimbe bark extract helps
improve penile erection by increasing blood flow. While Tribulus terrestris extract, maca
root extract and selenium increases the sperm count & motility. L opti, zinc, vitamin E
and panax ginseng are beneficial for boosting performance and stamina.

                <br />
               
              </p>
              {/* <blockquote
                style={{
                  backgroundImage: 'url("/images/blog/blog_details_2.jpeg")',
                }}
              >
                <p>
                  “Treatment for these disorders do exist and often involve a
                  combination of psychotherapy, behavioral therapy, and
                  medication.”
                </p>
              </blockquote> */}
              {/* <h2>
                How to Manage Anxiety Disorders: Techniques and Strategies
              </h2>
              <p>
                Anxiety disorders can be overwhelming and interfere with daily
                life, but there are ways to manage these feelings. From
                self-care strategies to professional help, below are methods to
                effectively cope with anxiety disorders.
              </p>
              <ul>
                <li>
                  <h3>1. Professional Treatment</h3>
                  If you are dealing with an anxiety disorder, seeking
                  professional help is crucial. Mental health professionals can
                  provide a diagnosis and suggest appropriate treatment options.
                  These typically include:
                </li>
                <li>
                  <h3>2. Self-Care Techniques</h3>
                  In addition to professional treatment, there are several
                  self-care strategies that you can adopt to help manage
                  anxiety: <br />
                  <br />
                  <b>Mindful meditation and relaxation techniques:</b> Deep
                  breathing exercises, progressive muscle relaxation, and
                  mindfulness meditation can reduce symptoms of anxiety by
                  promoting relaxation and reducing feelings of fear and worry.{' '}
                  <br />
                  <br />
                  <b>Healthy lifestyle:</b> Regular physical exercise, a healthy
                  diet, adequate sleep, and reducing caffeine and alcohol can
                  also help manage anxiety symptoms. <br />
                  <br />
                  <b>Maintaining a positive outlook:</b> While it may seem
                  challenging, it's beneficial to focus on positive aspects of
                  your life. Gratitude exercises or maintaining a journal to
                  record positive experiences can assist in cultivating an
                  optimistic outlook. <br />
                  <br />
                  <b>Avoiding avoidance:</b> It's common for people with anxiety
                  to avoid situations or objects that trigger their anxiety.
                  However, avoiding these triggers can reinforce the fear. Safe
                  exposure to these triggers under the guidance of a therapist
                  can help in managing and eventually reducing anxiety.
                </li>
                <li>
                  <h3>3. Utilizing Technology</h3>
                  There are numerous digital health platforms, such as
                  smartphone apps and online counseling services, that can help
                  manage anxiety disorders. These platforms can provide
                  cognitive-behavioral therapy, mindfulness training, and other
                  helpful resources.
                </li>
              </ul>
              <h2>Conclusion</h2>
              <p>
                Anxiety disorders can be daunting, but with the right
                combination of professional help and personal coping strategies,
                they can be managed effectively. It's essential to remember that
                help is available and that you're not alone in your struggle.{' '}
                <br />
                <br />
                Remember, it's crucial to reach out to a mental health
                professional if you're experiencing symptoms of an anxiety
                disorder. What works best will depend on the individual and the
                type of anxiety disorder, and it's essential to get a
                professional's guidance for effective management.
              </p> */}
            </div>
            {/* <Spacing md="85" /> */}
          
            {/* <Spacing md="110" /> */}
            {/* <CommentsWidget title="Comments" /> */}
            <Spacing md="92" />
            <ReplyWidget  />
          </div>
          <div className="col-lg-4">
            <Sidebar />
          </div>
        </div>
        <Spacing md="135" lg="100" />
       
      </div>
      <Spacing md="200" xl="150" lg="110" />
      {/* <Section className="cs_footer_margin_0">
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/banner_img_3.png"
        />
      </Section> */}
    </>
  );
}
